module.exports = __webpack_public_path__ + "fonts/qanelas_soft_extra_bold.9ea624ba.otf";